<template>
  <div class="menu-social-jet space-y-[20px]">
    <div v-for="item in menu" :key="item.text" class="flex flex-col">
      <span
        class="text-sm text-txmain/60 pl-4 mb-[12px] whitespace-nowrap md:opacity-0 group-hover:opacity-100 transition-all"
      >
        {{ item.text }}
      </span>
      <ul class="space-y-1">
        <li v-for="item in item.items" :key="item.text">
          <button @click="toNavigate(item.link)" class="w-full">
            <div
              class="flex items-center gap-3 p-3 whitespace-nowrap rounded-lg hover:bg-primary/[0.08] group-hover:px-3 transition-all"
              :class="{
                'text-primary bg-primary/[0.08] font-bold': isActivePath(item.link),
              }"
            >
              <component
                :is="item.icon"
                class="fill-txmain min-w-6"
                :class="{ '!fill-primary': isActivePath(item.link) }"
              />
              <span
                class="whitespace-nowrap md:opacity-0 group-hover:opacity-100 transition-all"
                :class="{
                  'text-primary font-bold': isActivePath(item.link),
                }"
              >
                {{ item.text }}
              </span>
              <span
                v-if="item.badge"
                class="text-sm font-bold text-primary bg-primary/[0.08] rounded-full px-2 ml-auto"
              >
                {{ item.badge }}
              </span>
            </div>
          </button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
  import { useUserStore } from "~/store/UserModule";
  import { markRaw } from "vue";
  import IOrders from "~/components/UINew/icons/IOrders.vue";
  import ICreative from "~/components/UINew/icons/ICreative.vue";
  import IMessages from "~/components/UINew/icons/IMessages.vue";
  import IPopularity from "~/components/UINew/icons/IPopularity.vue";
  import ISettings from "~/components/UINew/icons/ISettings.vue";
  import INews from "~/components/UINew/icons/INews.vue";
  import IDoc from "~/components/UINew/icons/IDoc.vue";
  import IResponseTime from "~/components/UINew/icons/IResponseTime.vue";
  import ICardBalance from "~/components/UINew/icons/ICardBalance.vue";
  import ICart from "~/components/UINew/icons/ICart.vue";
  import IHelp from "~/components/UINew/icons/IHelp.vue";

  const userModule = useUserStore();

  const route = useRoute();

  const menu = ref([
    {
      text: "Рекламные кампании",
      items: [
        {
          text: "Каталог",
          icon: markRaw(ICart),
          link: "/catalog",
          badge: null,
        },
        {
          text: "Заказы",
          icon: markRaw(IOrders),
          link: "/orders",
          badge: null,
        },
        {
          text: "Креативы",
          icon: markRaw(ICreative),
          link: "/creatives",
          badge: null,
        },
        {
          text: "Диалоги",
          icon: markRaw(IMessages),
          link: "/dialogs",
          badge: null,
        },
        {
          text: "Избранные каналы",
          icon: markRaw(IPopularity),
          link: "/favorites",
          badge: null,
        },
      ],
    },
    {
      text: "Настройки",
      items: [
        {
          text: "Баланс",
          icon: markRaw(ICardBalance),
          link: "/balance",
          badge: null,
        },
        {
          text: "Настройки",
          icon: markRaw(ISettings),
          link: "/settings",
          badge: null,
        },
      ],
    },
    {
      text: "Сервис",
      items: [
        {
          text: "Новости",
          icon: markRaw(INews),
          link: "https://t.me/TelePost_news",
          badge: null,
          target: "_blank",
        },
        {
          text: "Блог",
          icon: markRaw(IDoc),
          link: "/blog",
          badge: null,
        },
        {
          text: "Помощь",
          icon: markRaw(IHelp),
          link: "/help",
          badge: null,
        },
        {
          text: "Поддержка",
          icon: markRaw(IResponseTime),
          link: "/dialogs?to=support",
          badge: null,
        },
      ],
    },
  ]);

  const isActivePath = (path) => {
    return route.path === path;
  };

  const toNavigate = (path) => {
    if (path.startsWith("http")) {
      if (path?.target) {
        window.open(path, path?.target);
      } else {
        window.open(path);
      }
    } else {
      navigateTo(path);
    }
    userModule.isOpenMenu = false;
  };
</script>

<style>
  a {
    width: 100%;
  }

  .menu-social-jet {
    display: flex;
    padding-top: 10px;
    flex-direction: column;
  }
</style>
